import { useId } from 'react'

import { cn } from '@/lib/utils'

type MorningLogoMarkProps = {
  className?: string
  iconClassName?: string
}

export function MorningLogoMark({ className, iconClassName }: MorningLogoMarkProps) {
  const clipId = useId().replaceAll(':', '')

  return (
    <div
      className={cn(
        'flex shrink-0 items-center justify-center',
        className,
      )}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 237 123.2"
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={39.46}
        strokeWidth={18.74}
        className={cn('h-auto w-full text-orange-500', iconClassName)}
        aria-hidden
      >
        <defs>
          <clipPath id={clipId}>
            <path d="M237 123.2H0V0h234.18z" />
          </clipPath>
        </defs>
        <g clipPath={`url(#${clipId})`}>
          <circle cx="117.23" cy="119.34" r="108.52" />
          <circle cx="117.23" cy="119.34" r="74.98" />
          <path d="M231.64 114.58H42.26" />
        </g>
      </svg>
    </div>
  )
}
